/**
 *
 *                          WAIT !!!
 *
 * You most likely should NOT be using (or adding) anything in here.
 *
 * Colours in our app should solely be defined in the theme.ts file.
 * Use an existing palette colour, or if necessary, add a new one to
 * the theme as required.
 *
 */

export const darkGrey = 'rgba(0, 0, 0, 0.54)'
export const lightGrey = 'rgba(229,229,229)'
export const disabledGrey = 'rgba(0, 0, 0, 0.38)'
export const darkLightError = 'rgba(183, 61, 59, 1)'
export const borderGreyColor = 'rgba(185,185,185)'
export const lightError = 'rgba(250, 107, 91, 1)'
export const white = 'rgba(255, 255, 255, 1)'

export const alertDetails = 'rgb(235 220 220)'

export const ErrorBackground = '#FF000026'
export const ErrorBackgroundHover = '#FF000020'

export const InfoBackground = '#eef2fb'
export const InfoBackgroundHover = '#f4f7fc'

export const ClipBoardIconColor = '#CDCDCD'
